import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    invList: [],
};
const getters = {
    getInv: state => state.invList

};

const mutations = {
    INV_INFO(state, data) {
        state.invList = data
    }
};

const actions = {
    getInv({commit}) {
        axiosGet(`crm/inv/types`).then((response) => {
            commit('INV_INFO', response.data.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
